import React from 'react';
import styled from 'styled-components';
import colors from '../../theme/colors';

const SearchContainer = styled.div`
  background: ${colors.base.themePrimary};
  border: 2px solid ${colors.border.lightHover};
  border-radius: 40px;
  padding: 10px;
  min-width: 300px;
  position: relative;
`;

const SearchHeader = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const CloseButton = styled.button`
  background: ${colors.background.transparent};
  border: 1px solid ${colors.border.lightHover};
  border-radius: 45%;
  color: white;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.9rem;
  min-width: 44px;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.button.aboutBgHover};
    border-color: ${colors.border.lightHover};
  }

  &:active {
    transform: scale(0.98);
  }
`;

const SearchInput = styled.input`
  flex: 1;
  background: ${colors.background.overlay};
  border: 1px solid ${colors.border.lightHover};
  border-radius: 20px;
  color: white;
  padding: 8px 12px;
  font-size: 0.9rem;

  &::placeholder {
    color: ${colors.text.lightSecondary};
  }

  &:focus {
    outline: none;
    border-color: ${colors.border.lightHover};
  }
`;

const SearchResults = styled.div`
  max-height: 200px;
  overflow-y: auto;
  margin-top: 5px;
  /* Re-enable native vertical scrolling inside the camera's touch-action: none zone */
  touch-action: pan-y;
  overscroll-behavior: contain;
`;

const SearchResultItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  color: ${colors.text.light};
  font-size: 0.9rem;

  &:hover {
    background: ${colors.accent.orangeLight};
  }

  .node-title {
    font-weight: 500;
  }

  .node-path {
    font-size: 0.8rem;
    color: ${colors.base.accentPrimary};
    margin-top: 2px;
  }
`;

const SearchComponent = ({
  searchQuery,
  searchResults,
  onSearchChange,
  onSelectResult,
  onClose,
  translations
}) => {
  return (
    <SearchContainer>
      <SearchHeader>
        <SearchInput
          type="text"
          placeholder={translations?.searchPlaceholder || "Search nodes by title or description..."}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          autoFocus
        />
        <CloseButton onClick={onClose} title="Close search (Esc)">
          ✕
        </CloseButton>
      </SearchHeader>
      {searchResults.length > 0 && (
        <SearchResults data-camera-scrollable onWheel={(e) => e.stopPropagation()}>
          {searchResults.map(node => {
            // Only show path if level is 2 or higher (skip root and main categories)
            const shouldShowPath = node.level >= 2;
            // Filter out level 0 nodes from the path
            const pathText = shouldShowPath && node.parentPath && node.parentPath.length > 0
              ? node.parentPath.filter(p => p.level > 0).map(p => p.title).join(' > ')
              : null;

            return (
              <SearchResultItem
                key={node.id}
                onClick={() => onSelectResult(node)}
              >
                <div className="node-title">{node.title}</div>
                {pathText && <div className="node-path">{pathText}</div>}
              </SearchResultItem>
            );
          })}
        </SearchResults>
      )}
    </SearchContainer>
  );
};

export default SearchComponent;
